import React from 'react';
import { Row, Col, Card } from 'react-bootstrap';
import { TokenStatsProps } from './types';
import { ScoreBoardNumber } from './ScoreBoardNumber';
const getAverageServiceTime = (input: string | number) => {
  const seconds = parseFloat(input as string) || 0

  if (seconds < 60) {
    return { value: Math.round(seconds), suffix: 'sec' }
  } else if (seconds < 3600) {
    return { value: Math.round(seconds / 60), suffix: 'min' }
  } else {
    return { value: (seconds / 3600).toFixed(1), suffix: 'hrs' }
  }
}

export const TokenStatsCards: React.FC<TokenStatsProps> = ({ waiting, avgWait, avgService }) => (
  <Row>
    <Col className="p-0">
      <Card>
        <Card.Header className="bg-dark text-white">No Of Customers Waiting</Card.Header>
        <Card.Body className="text-center">
          <ScoreBoardNumber number={waiting} />
        </Card.Body>
      </Card>
    </Col>
    <Col className="p-0">
      <Card>
        <Card.Header className="bg-dark text-white">Average Waiting Time</Card.Header>
        <Card.Body className="text-center">
          <ScoreBoardNumber number={avgWait} suffix="min" />
        </Card.Body>
      </Card>
    </Col>
   {avgService !== undefined && (
  <Col className="p-0">
    <Card style={{ height: '300px' }}>
      <Card.Header className="bg-dark text-white">Average Service Time</Card.Header>
      <Card.Body className="text-center">
        {(() => {
          const { value, suffix } = getAverageServiceTime(avgService)
          return <ScoreBoardNumber number={value} suffix={suffix} />
        })()}
      </Card.Body>
    </Card>
  </Col>
)}
  </Row>
);
